/**
 * Checkout-only payment UI getters mapped by shared mixins/components.
 * Non-checkout stores stub falsey values so Vuex 4 does not report unknown getters.
 *
 * Portal must use portalSharedPaymentUiGetterStubs — change-order / nested cart /
 * customer already own amount_due, coupon_list, and einvoice_schemes; falsey stubs
 * there can win the Vuex merge and hide real totals/coupons/schemes.
 *
 * Paynow has customer (einvoice_schemes) but no cart/order — stub totals/coupons only.
 * Claim-gift registers neither cart nor customer — stub totals/coupons/einvoice too.
 */

export const paymentMethodFlagGetterStubs = {
  one_screen_checkout: () => false,
  retain_pm_option: () => false,
  hasTrialPeriod: () => false,
  is_ideal_payment: () => false,
  is_online_banking_poland_payment: () => false,
  is_boleto_payment: () => false,
  is_klarna_payment: () => false,
  is_klarna_pay_now_payment: () => false,
  is_payconiq_by_bancontact_payment: () => false,
  is_payless_checkout: () => false,
};

/** Paynow: no cart/order module — stub totals/coupons. customer owns einvoice_schemes. */
export const paynowSharedPaymentUiGetterStubs = {
  ...paymentMethodFlagGetterStubs,
  amount_due: () => 0,
  current_amount_due: () => 0,
  coupon_list: () => [],
};

/** Claim-gift: no cart/customer modules — stub totals/coupons/einvoice too. */
export const claimGiftSharedPaymentUiGetterStubs = {
  ...paynowSharedPaymentUiGetterStubs,
  collect_now_selected_offline_payment: () => false,
  einvoice_schemes: () => [],
};

/** Portal: change-order + cart + customer already provide totals/coupons/einvoice. */
export const portalSharedPaymentUiGetterStubs = {
  ...paymentMethodFlagGetterStubs,
};
